import { cn } from "@/lib/cn";
import { formatPLN } from "@/lib/format";
import { Badge } from "@/components/ui/Badge";
import { Invoice, InvoiceStatus } from "@/types/billing";

const statusLabels: Record<InvoiceStatus, string> = {
  draft: "Szkic", finalized: "Gotowe", sent: "Wysłano",
};
const statusTones: Record<InvoiceStatus, "muted" | "success" | "info"> = {
  draft: "muted", finalized: "info", sent: "success",
};

interface Props {
  invoices: Invoice[];
  selectedId: string | null;
  onSelect: (agreementId: string) => void;
  showStatus?: boolean;
}

export function TenantList({ invoices, selectedId, onSelect, showStatus }: Props) {
  return (
    <div className="flex flex-col gap-1.5 lg:w-72 shrink-0 lg:overflow-y-auto">
      {invoices.map((inv) => {
        const selected = inv.agreement_id === selectedId;
        return (
          <button
            key={inv.agreement_id}
            onClick={() => onSelect(inv.agreement_id)}
            className={cn(
              "text-left px-3 py-2 border border-border rounded-lg bg-bg-elevated relative",
              "hover:bg-bg-subtle transition-colors duration-150",
              selected && "bg-bg-subtle before:absolute before:left-0 before:top-1 before:bottom-1 before:w-0.5 before:bg-accent",
            )}
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-text">{inv.tenant_name}</span>
              {showStatus && <Badge tone={statusTones[inv.status]}>{statusLabels[inv.status]}</Badge>}
            </div>
            <div className="flex items-center justify-between text-xs text-text-muted mt-0.5">
              <span className="capitalize">{inv.location}</span>
              <span className="font-mono">{formatPLN(inv.total_amount)}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
